import StudySummary from './StudySummary';

export default StudySummary;
